import React, { useEffect, useRef, useState } from 'react';
import NavBar from '../ProductPage_v2/components/Navbar/Navbar';
import FooterSection from '../ProductPage_v2/components/footer/footer';
import callApi from '../../utility/apiCaller';
import { toast } from 'react-toastify';
import { setUserClickData } from '../../utility/setUserClickData';
import { ClipLoader } from 'react-spinners'
import UnsubscribeSuccess from './ThanksPage';

export default function DNDService() {
    const [fullName, setFullName] = useState('');
    const [error, setError] = useState('')
    const [mobile, setMobile] = useState('');
    const [otpGenerated, setOtpGenerated] = useState(false);
    const [otp, setOtp] = useState(['', '', '', '']);
    const [formData, setformData] = useState({
        fullName: '',
        mobile: ''
    })
    const [isLoading, setIsLoading] = useState(false)
    const [isUnsubscribeLoading, setIsUnsubscribeLoading] = useState(false)
    const inputRefs = useRef([]);
    const [step, setSteps] = useState(1)


    useEffect(() => {
        console.log(formData)
    }, [formData])

    const handleOtpChange = (index, value) => {
        if (!/^\d*$/.test(value)) return; // only digits allowed

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next input if value is filled
        if (value && index < 3) {
            inputRefs.current[index + 1]?.focus();
        }

        // Move to previous if cleared
        if (!value && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const handleSendOtp = async () => {
        console.log("Form data:", formData);
        console.log("Triggered OTP send");

        // Validate mobile number
        if (mobile.length !== 10) {
            toast.error("Please enter a valid 10-digit mobile number.");
            return;
        }


        if (!fullName.trim()) {
            toast.error("Please enter your full name.");
            return;
        }
        setformData({
            fullName: fullName,
            mobile: mobile
        })



        try {
            setIsLoading(true);

            const response = await callApi(
                "v1/sms/send-otp",
                "post",
                {
                    contact_phone: mobile,

                },
                "messaging"
            );

            if (response.status === "Success") {
                // Optional analytics
                setUserClickData({
                    event_name: "otp-send-for-unsubscribe-request",
                    user_id: mobile || "unknown",
                    page: "unsubscribe-page",
                    timestamp: new Date().toISOString(),
                });

                setformData((prev) => ({
                    ...prev,
                    mobile,
                    otpSentAt: new Date().toISOString(),

                }));

                toast.success("OTP Sent Successfully");
                setOtpGenerated(true)
            } else {
                toast.error("Failed to send OTP. Please try again.");
            }
        } catch (error) {
            toast.error("An error occurred while sending OTP.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleMobileChange = (e) => {
        const input = e.target.value;
        const numericValue = input.replace(/\D/g, '').slice(0, 10); // limit to 10 digits

        if (numericValue.length === 10) {
            setMobile(numericValue);
            setError("");
        } else {
            setMobile(numericValue); // keep updating until 10 digits
            setError("Mobile number must be exactly 10 digits.");
        }
    };


    const handleResendOtp = async () => {
        try {
            setIsLoading(true);
            const response = await callApi(
                "v1/sms/send-otp",
                "post",
                {
                    contact_phone: mobile,
                },
                "messaging"
            );
            if (response.status === "Success") {
                setUserClickData({
                    event_name: "otp-resend-for-unsubscribe-request",
                    user_id: mobile || "unknown",
                    page: "unsubscribe-page",
                    timestamp: new Date().toISOString(),
                });

                toast.success("OTP Resent Successfully");
            } else {
                toast.error("Failed to resend OTP.");
            }
        } catch (error) {
            console.error(error);
            toast.error("An error occurred while resending OTP.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleOtpSubmit = async () => {
        const finalOtp = otp.join(""); // Join ["1", "2", "3", "4"] into "1234"

        if (finalOtp.length !== 4) {
            toast.error("Please enter a valid 4-digit OTP.");
            return;
        }

        setIsUnsubscribeLoading(true)
        try {
            const otpResponse = await callApi(
                "v1/sms/validate-otp",
                "post",
                {
                    contact_phone: mobile,
                    otp: finalOtp,
                },
                "messaging"
            );

            if (otpResponse.status === "Success") {
                setUserClickData({
                    event_name: "otp-submit-for-unsubscribe-page",
                    user_id: mobile || "unknown",
                });


                const unsubscribeResponse = await callApi(
                    "v1/whatsapp_unsubscribe/add-new-wa-block-number",
                    "post",
                    {
                        whatsapp_unsubscribe: {
                            contact_phone: mobile,
                            source: "website",
                        },
                    },
                    "messaging"
                );

                if (unsubscribeResponse.status === "Success") {
                    // Custom event after successful unsubscribe
                    setUserClickData({
                        event_name: "user-unsubscribed-successfully",
                        user_id: mobile || "unknown",
                        timestamp: new Date().toISOString(),
                    });

                    setSteps(2);
                } else {
                    const errorMsg = unsubscribeResponse?.data?.message;
                    console.log(unsubscribeResponse)

                    if (
                        errorMsg?.toLowerCase().includes("already blocked") ||
                        errorMsg?.toLowerCase().includes("already unsubscribed")
                    ) {
                        toast.info("This number is already unsubscribed.");
                        // Optional: Proceed to success screen anyway
                    } else {
                        toast.error(errorMsg || "Something went wrong. Please try again.");
                    }
                }

            } else {
                toast.error("Invalid OTP. Please try again.");
            }
        } catch (otpError) {
            console.error("Error occurred while verifying OTP:", otpError);

            let errorMessage = "";

            // Try multiple levels to extract a message
            errorMessage = JSON.stringify(otpError?.response?.data?.data);

            const normalizedMessage = errorMessage.toLowerCase();
            console.log("Normalized error message:", normalizedMessage);

            if (
                normalizedMessage.includes("already blocked") ||
                normalizedMessage.includes("already unsubscribed")
            ) {
                toast.info("This number is already unsubscribed.");
                setOtp(["", "", "", ""])
                setFullName("")
                setMobile("")
                setOtpGenerated(false)
            } else {
                toast.error("An error occurred while verifying OTP. Please try again.");
            }
        } finally {
            setIsUnsubscribeLoading(false)
        }


    };




    const handleUnsubscribe = () => {
        const finalOtp = otp.join('');
        alert(`OTP entered: ${finalOtp}\nUnsubscribed ${fullName} (${mobile})`);
    };

    return (
        <>
            {(step === 1) ? <div className="min-h-screen relative z-0  flex flex-col pt-6 bg-[#FBF8F3] overflow-hidden">
                <img src="/assets/img/bgGrid.png" className="absolute top-0 left-0  h-auto w-auto sm:h-full sm:w-full   -z-10" />
                <div className='w-[90vw] sm:w-full max-w-6xl mx-auto'>
                    <NavBar />
                </div>
                <div className=" w-full flex flex-col gap-5 font-atkinson mx-auto rounded-xl p-8">

                    <div className='w-full flex flex-col max-w-6xl mx-auto'>

                        <h2 className="text-3xl  text-[#0B3B60] font-bomstad-semibold mb-2">DND Service</h2>
                        <p className="text-[#4A4A4A] mb-6">
                            We value your time and privacy. In case you don’t wish to hear from us, you can choose to opt out.
                        </p>

                    </div>

                    <div className="w-full max-w-7xl mx-auto flex justify-center flex-col md:flex-row gap-4 mb-6">
                        {/* Full Name */}
                        <div className=" flex-1 flex flex-col w-full ">
                            <label className="text-sm font-medium text-[#B3B3B3] mb-1">Full Name</label>
                            <input
                                type="text"
                                placeholder="Enter your full name"
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                                className="border-1 h-[55px] border-gray-400 rounded-lg px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* Mobile Number */}
                        <div className="flex-1  relative flex flex-col w-full ">
                            <label className="text-sm font-medium text-[#B3B3B3] mb-1">Mobile Number</label>
                            <input
                                type="tel"
                                placeholder="Enter your mobile number"
                                value={mobile}
                                maxLength={10}
                                pattern="[0-9]{10}"
                                onChange={handleMobileChange}
                                onKeyDown={(e) => {


                                    const isAlphabet = /^[A-Za-z]$/.test(e.key);
                                    const isCtrlCombo = e.ctrlKey || e.metaKey;

                                    if (isAlphabet && !isCtrlCombo) {
                                        e.preventDefault();
                                        console.log("Blocked alphabet key:", e.key);
                                    }


                                }}
                                className={`border-1 h-[55px] rounded-lg px-4 py-2 w-full focus:outline-none focus:ring-2 ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-400 focus:ring-blue-500'
                                    }`}
                            />
                            {error && <p style={{ color: 'red' }} className='absolute -bottom-5 left-1 text-xs'>*{error}</p>}
                        </div>

                        {/* OTP Section */}
                        {otpGenerated && (
                            <div className=" flex-1 flex flex-col w-full">
                                <label className="text-sm font-medium text-[#B3B3B3] mb-1">Mobile OTP Verification</label>
                                <div className="flex gap-2  rounded-lg  ">
                                    {otp.map((digit, idx) => (
                                        <input
                                            key={idx}
                                            type="text"
                                            maxLength="1"
                                            placeholder="_"
                                            value={digit}
                                            ref={(el) => (inputRefs.current[idx] = el)}
                                            onChange={(e) => handleOtpChange(idx, e.target.value)}
                                            className="w-[55px] h-[55px] text-center border-1 border-gray-400 rounded-md text-lg font-semibold focus:outline-none"
                                        />
                                    ))}
                                </div>
                                <div className="mt-2 text-xs text-[#B3B3B3]">

                                    Don’t receive the OTP? Click here to <span className='text-blue-500 hover:underline cursor-pointer'
                                        onClick={handleResendOtp}
                                    >Resend OTP</span>

                                </div>
                            </div>
                        )}

                        {!otpGenerated && <div className="flex-1 flex items-end ">

                            <button
                                onClick={handleSendOtp}
                                className="w-full h-[55px] flex justify-center items-center bg-[#0B3B60] text-white px-6 py-3 rounded-lg hover:bg-[#0A2E4F] transition"
                            >
                                {
                                    isLoading ? <ClipLoader
                                        color='white'
                                        size={25}
                                    /> : "Generate OTP"
                                }
                            </button>

                        </div>}

                        {/* Unsubscribe Button */}
                        <div className="flex-1 flex items-end max-h-[80px] ">
                            <button
                                onClick={handleOtpSubmit}
                                disabled={!otpGenerated}
                                className="w-full h-[55px] bg-black text-white px-6 py-3 rounded-lg disabled:bg-gray-400 hover:bg-gray-800 transition flex items-center justify-center gap-2"
                            >
                                {isUnsubscribeLoading ? <ClipLoader
                                    color='white'
                                    size={25}
                                /> : <>
                                    Unsubscribe
                                    <img
                                        src="/assets/img/CTA Arrow black.svg"
                                        className="h-[16px] w-[21px]"
                                        alt="Arrow"
                                    />
                                </>}

                            </button>
                        </div>

                    </div>



                    {/* Terms */}
                    <ul className="text-sm w-full  max-w-6xl mx-auto text-gray-600  space-y-2 list-disc pl-6">
                        <li>
                            By registering for DND, you will not be contacted by DigitMoney.in regarding offers. The phone number
                            shared by you will be excluded from such calls or notifications. If you change your mobile number, you
                            will have to re-register for DND with your new number.
                        </li>
                        <li>
                            DigitMoney co-branded credit cardholders will continue to receive important information pertaining to
                            their co-branded cards.
                        </li>
                        <li>DigitMoney.in needs about 72 business hours to process your DND request.</li>
                        <li>
                            This registration is only for users registered on DigitMoney.in and not for banking partners or affiliates.
                        </li>
                        <li>You will receive an email confirming your registration of DND services.</li>
                        <li>
                            This registration will not stop unsolicited commercial calls from other banks, lending institutions, and
                            entities unaffiliated to DigitMoney.in.
                        </li>
                    </ul>
                </div>

            </div> : <UnsubscribeSuccess />}
            <FooterSection />
        </>
    );
}
